<template>
  <v-container
    class="ma=0 pa-0"
  >
    <v-row
      justify="center"
      align="center"
    >
      <v-col
        class="ma-0 pa-0"
        id="design-column"
        xs="0"
      >
        <v-img
          :contain="true"
          id="login-logo"
          :src="logo"
        />
      </v-col>
      <v-col
        id="login-column"
        style="height: 100%"
        class="pa-0 ma-0"
        xs="12"
      >
        <v-img
          :src="orangeWave"
          id="wave-bg"
        />
        <v-row
        justify="center"
        >
          <v-scroll-x-transition :hide-on-leave="true">
            <LoginCard
              v-if="$route.path.includes('login')"
            />
          </v-scroll-x-transition>
          <v-scroll-x-reverse-transition :hide-on-leave="true">
            <ActivateCard
              v-if="$route.path.includes('activate')"
            />
          </v-scroll-x-reverse-transition>
          <v-scroll-x-reverse-transition :hide-on-leave="true">
            <ForgotPasswordCard
              v-if="$route.path.includes('forgotPassword')"
              @password-reset-response="handlePasswordResetResponse"
            />
          </v-scroll-x-reverse-transition>
          <v-scroll-x-reverse-transition :hide-on-leave="true">
            <ResetPasswordCard
              v-if="$route.path.includes('reset')"
              @password-update-response="handlePasswordUpdateResponse"
            />
          </v-scroll-x-reverse-transition>
        </v-row>
      </v-col>
    </v-row>
    <BaseSnackbar
      :visible="snackbarVisible"
      :text="snackbarText"
      @close="snackbar = false"
    />
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'

import LoginCard from './LoginCard'
import ActivateCard from './ActivateCard'
import ForgotPasswordCard from './ForgotPasswordCard'
import ResetPasswordCard from './ResetPasswordCard'
import BaseSnackbar from '@/components/base/BaseSnackbar'

export default {
  data: () => ({
    logo: require('@/assets/logo_v2.svg'),
    orangeWave: require('@/assets/orange_multiwave.svg'),
    snackbarVisible: false,
    snackbarText: '',
    snackbarDefaultTimeout: 5000
  }),

  components: {
    LoginCard,
    ActivateCard,
    ForgotPasswordCard,
    ResetPasswordCard,
    BaseSnackbar
  },

  mounted () {
    // this.rootIsInitialized().then(response => {
    //   console.log('ROOT IS INITIALIZED', response)
    //   if (response === false) {
    //     console.log('pushing')
    //     this.$router.push('/activate?token=root')
    //   }
    // })
  },

  methods: {
    ...mapMutations(['removeBearerToken']),
    async rootIsInitialized () {
      var response = await fetch(process.env.VUE_APP_API_BASE + '/id/initStatus')

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      } else {
        var json = await response.json()

        return json.isInit
      }
    },

    handlePasswordResetResponse (response) {
      console.log(response)
      if (response.success) {
        this.showSnackbar('Successfully sent reset link to email.')
      } else {
        this.showSnackbar('The provided email address is not registered.', 7000)
      }
    },

    handlePasswordUpdateResponse (response) {
      console.log(response)
      if (response.success) {
        this.showSnackbar('Successfully updated password.')
      } else {
        this.showSnackbar('Could not update password', 7000)
      }
    },

    showSnackbar (text, timeout = null) {
      let snackbarTimeout = this.snackbarDefaultTimeout
      if (timeout !== null) {
        snackbarTimeout = timeout
      }

      this.snackbarText = text
      this.snackbarVisible = true
      setTimeout(() => { this.snackbarVisible = false }, snackbarTimeout)
    }
  }
}
</script>

<style lang="sass" scoped>

  #login-logo
    height: 100vh
    max-width:40vw
    right: 25rem

  #design-column
    height: 100%
    width: 100%

  #wave-bg
    height: 100%
    width: 100%
    position: absolute
    top: 0rem
    left: 0rem
</style>
